<template>
  <Teleport to="body">
    <Transition name="modal">
      <div
        v-if="isVisible"
        class="paywall-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="paywall-title"
        @click.self="dismiss"
      >
        <div class="paywall-card">
          <div class="paywall-icon" aria-hidden="true">✨</div>
          <h2 id="paywall-title">You've used all your credits</h2>
          <p class="paywall-sub">
            Upgrade to keep generating previews.
            <span v-if="creditsRemaining !== null">
              You have {{ creditsRemaining }} credit{{ creditsRemaining === 1 ? '' : 's' }} remaining.
            </span>
          </p>
          <div class="paywall-actions">
            <button class="btn-primary" @click="handleUpgrade">Upgrade now</button>
            <button class="btn-ghost" @click="dismiss">Maybe later</button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useAuthStore } from '@/store/authStore'

const authStore = useAuthStore()
const isVisible = ref(false)

// S5 decision: read credits directly from authStore.currentUser.billing (no new store for MVP)
const creditsRemaining = computed(
  () => authStore.currentUser?.billing?.credits_remaining ?? null
)

function handleCreditsExhausted() {
  isVisible.value = true
}

function dismiss() {
  isVisible.value = false
}

function handleUpgrade() {
  // TODO S6: wire to createCheckoutSession() from @/api/billing
  isVisible.value = false
}

onMounted(() => window.addEventListener('credits:exhausted', handleCreditsExhausted))
onUnmounted(() => window.removeEventListener('credits:exhausted', handleCreditsExhausted))
</script>

<style scoped>
.paywall-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.paywall-card {
  background: #fff;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.paywall-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
}

.paywall-sub {
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.paywall-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.btn-primary {
  background: #01696f;
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 180ms ease;
}

.btn-primary:hover {
  background: #0c4e54;
}

.btn-ghost {
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: color 180ms ease;
}

.btn-ghost:hover {
  color: #555;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
